<template>
	<div id="app">
		<router-view/>
	</div>
</template>
<script>
export default {
	created() {
		document.title = this.$t('新生網路報到')
	},
	watch: {
		'$i18n.locale': function() {
			document.title = this.$t('新生網路報到')
		},
	},
}
</script>
<style>
@import './assets/css/global.css';

#app {
	font-family: 'Helvetica Neue', 'Avenir', Helvetica, 'Microsoft YaHei', Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	min-height: 100%;
}
html {
	padding: 0 0;
	margin: 0 0;
	height: 100%;
}

body {
	position: relative;
	min-height: 100%;
}
</style>
